import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { MAX_COMPARISON_RUNS } from "./simulatorComparisonTypes";

export type SimulatorComparisonQuotaProps = {
  used: number;
  max?: number;
  subtleText: string;
  /** Compact pill for hero / toolbars; default is inline text beside section titles. */
  variant?: "inline" | "pill";
};

export function SimulatorComparisonQuota({
  used,
  max = MAX_COMPARISON_RUNS,
  subtleText,
  variant = "inline",
}: SimulatorComparisonQuotaProps): React.ReactElement {
  const atLimit = used >= max;
  const label = `${used} / ${max} simulations`;

  if (variant === "pill") {
    return (
      <Box
        as="span"
        display="inline-flex"
        alignItems="center"
        px={3}
        py={1}
        borderRadius="6px"
        borderWidth="1px"
        borderColor={atLimit ? "orange.300" : "gray.200"}
        bg={atLimit ? "orange.50" : "var(--content-canvas)"}
        flexShrink={0}
      >
        <Text
          as="span"
          fontSize="xs"
          fontFamily="'IBM Plex Sans', sans-serif"
          fontWeight="medium"
          color={atLimit ? "orange.700" : "gray.500"}
          m={0}
          lineHeight="1.2"
        >
          {label}
        </Text>
      </Box>
    );
  }

  return (
    <Text
      as="span"
      fontSize="sm"
      fontFamily="'IBM Plex Sans', sans-serif"
      color={atLimit ? "orange.600" : subtleText}
      fontWeight={atLimit ? "semibold" : "normal"}
      m={0}
      lineHeight="1.4"
    >
      {label}
      {atLimit ? " — remove a run to add another" : null}
    </Text>
  );
}
